module.exports = __webpack_public_path__ + "img/announcement.bc4773fa.png";